import script from "./artemisadsTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./artemisadsTextarea.vue?vue&type=script&setup=true&lang=js"

import "./artemisadsTextarea.vue?vue&type=style&index=0&id=607a9c79&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607a9c79"]])

export default __exports__